import React from "react";
import { createPortal } from "react-dom";
import { QRCodeCanvas } from "qrcode.react";
import { setPrintPageSize, clearPrintPageSize } from "../lib/printPageSize";
import { elementToPdf, pdfFileName } from "../lib/pdfExport";

// Etichetta QR singola 62×100 mm (rullo Brother DK-11202, stesso formato di
// lib/labelFormats.js "62x100"): una etichetta per ogni QR selezionato, usata
// da QR materie prime, QR produzioni frigo/celle e Libro ingredienti accanto
// ai formati A4. Le misure sono in var(--u): 4px per mm a schermo (anteprima
// 400×248 px), 1mm in stampa (index.css), così anteprima, PDF e stampa diretta
// hanno la stessa impaginazione.
export const LABEL_62X100 = { widthMm: 100, heightMm: 62, previewPx: 400 };

export function QrLabel62x100({ url, kicker, title, note, scanText, footer }) {
  return (
    <div className="qr-label-62 bg-white text-navy" data-testid="qr-label-62">
      <div className="qr-label-62-text">
        {kicker && <div className="qr-label-62-kicker">{kicker}</div>}
        <div className="qr-label-62-title font-heading">{title}</div>
        {note && <div className="qr-label-62-note">{note}</div>}
        <div className="qr-label-62-scan">{scanText}</div>
        {footer && <div className="qr-label-62-footer">{footer}</div>}
      </div>
      <QRCodeCanvas value={url} size={320} fgColor="#0B1D3A" level="M" className="qr-label-62-qr" />
    </div>
  );
}

// Anteprima a schermo + copia per window.print() portalata in document.body
// (stesso motivo di QrProduzioniCelle/Etichette: evita pagine fantasma).
export function QrLabel62x100Sheet({ labels, sheetRef }) {
  const list = labels.map((label) => <QrLabel62x100 key={label.key} {...label} />);
  return <>
    <div className="no-print overflow-x-auto" ref={sheetRef}>
      <div className="flex flex-wrap gap-4">{list}</div>
    </div>
    {createPortal(<div className="print-area qr-label-62-print">{list}</div>, document.body)}
  </>;
}

export function printQrLabels62x100() {
  document.body.setAttribute("data-print", "qr-label-62");
  setPrintPageSize(LABEL_62X100.widthMm, LABEL_62X100.heightMm);
  setTimeout(() => { window.print(); document.body.removeAttribute("data-print"); clearPrintPageSize(); }, 60);
}

// PDF con una pagina 100×62 mm per etichetta (win: da preparePdfWindow()).
export function qrLabels62x100Pdf(container, win, ...nameParts) {
  return elementToPdf(container, {
    fileName: pdfFileName("etichette-qr-62x100", ...nameParts),
    widthMm: LABEL_62X100.widthMm,
    heightMm: LABEL_62X100.heightMm,
    renderWidthPx: LABEL_62X100.previewPx,
    pageSelector: ".qr-label-62",
    win,
  });
}
